export default __webpack_public_path__ + "static/media/icon-user.4e77bde2.svg";